import { q } from 'groqd'

import { imageAsset } from '@/cms/helperTypes'

export const marketQuery = q('*')
  .filter('_type == "market"')
  .grab({
    market: q.string(),
    name: q.string(),
    flagImage: q('flagImage').grab({
      _type: q.literal('image'),
      asset: q('asset').deref().grab(imageAsset),
    }),
    marketLinks: q('marketLinks')
      .filter()
      .grab({
        heading: ['heading[$lang]', q.string().nullable()],
        url: ['url[$lang]', q.string().nullable()],
        key: q.string(),
      }),
    customerServiceContactMail: q.string(),
    customerServiceContactNumber: q.string(),
    tradingName: q("legalTexts[key match 'tradingName']")
      .filter()
      .grab({
        text: q('legalTextReference').deref().grabOne('contentHtml[$lang]', q.string().nullable()),
      }),
    availableEnvironments: q
      .array(q.union([q.literal('staging'), q.literal('production')]))
      .nullable(),
    availableLanguages: q.array(q.string()),
  })
